export default __webpack_public_path__ + "static/media/Chamber-Media-Logo.3c225854.png";